export default "__VITE_ASSET__ncDoecYU__"